module.exports = __webpack_public_path__ + "static/media/service7.084cb70d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/service7.jpeg
// module id = 318
// module chunks = 0